import React, {useState, useEffect} from 'react'
import firebase from "../../../Config/firebase";
import {MDBBtn, MDBTable, MDBTableBody, MDBTableHead} from 'mdbreact';
import {getCountry} from "../../../Utils/countries";
import ApprovalItem from "./ApprovalItem/ApprovalItem";
import {getAPIPath} from "../../../Utils/HelpingFunction";

const db = firebase.firestore()
const ApprovalPage = (props) => {

    const [items, setItems] = useState([])
    const [noItem, setNoItem] = useState(false)
    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        getPendingItems()
    }, [])

    const getPendingItems = () => {
        db.collection('Pending')
            .limit(50)
            .where("rejected" , "==", false)
            .get()
            .then(res => {
                if (!res.empty) {
                    let allItems = []
                    res.forEach(doc => {
                        allItems.push({
                            ...doc.data(),
                            id: doc.id
                        })
                    })
                    setItems(allItems)
                    setIsLoaded(true)
                } else {
                    setNoItem(true)
                    setIsLoaded(true)
                }
            })
    }

    const approvalItem = async (itemID) => {
        return await new Promise((resolve, reject) => {
            fetch(getAPIPath("/api/admin/approve"), {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    uid: props.auth.uid,
                    pendingID: itemID
                })
            }).then((res) => res.json()).then((searchResult) => {
                if (searchResult.success) {
                    removeListItem(itemID)
                }
            })
        })
    }

    const rejectItem = (itemID) => {
        db.collection('Pending')
            .doc(itemID)
            .update({
                rejected:true
            })
            .then(res => {
                removeListItem(itemID)
            })
    }

    const removeListItem = (itemID) => {
        let newItems = items
        newItems = newItems.filter(e => e.id !== itemID)
        setItems(newItems)
    }

    if (isLoaded && items.length > 0) {
        return (
            <div>
                <MDBTable>
                    <MDBTableHead color="primary-color" textWhite>
                        <tr>
                            <th>#</th>
                            <th>Category</th>
                            <th>Type</th>
                            <th>Title</th>
                            <th>Country Name</th>
                            <th>Action</th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                        {items.map((e, index) => {
                            return (
                                <ApprovalItem
                                    key={e.id}
                                    data={e}
                                    approvalItem={approvalItem}
                                    rejectItem={rejectItem}
                                    index={index}
                                />
                            )
                        })}
                    </MDBTableBody>
                </MDBTable>
            </div>
        )
    } else if (isLoaded && noItem) {
        return (
            <div>
                no item
            </div>
        )
    } else {
        return (
            <div>
                loading...
            </div>
        )
    }
}
export default ApprovalPage